define('shared/remote/country/get',[
    '$',
    './Entity',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/util/fetch'
], function (
    $,
    CountryEntity,
    RSVP,
    console,
    fetch
) {
    'use strict';

    var NAME = 'shared/remote/country/get';

    function sendRequest(marketCode) {
        return fetch(
            '/etc/appconfig/b2c/lists/countries/' + marketCode + '/countries/' + 
            marketCode + '.2.json', {
                credentials: 'same-origin'
            })
            .then(function(response){
                return response.json();
            });
    }

    var cache = {};

    return function get(marketCode) {

        if (!cache[marketCode]) {
            cache[marketCode] = sendRequest(marketCode)
                .then(function succeeded(cqJson) {
                    var ret = new CountryEntity(cqJson);
                    return RSVP.resolve(ret);
                },
                function failed() {
                    console.error(NAME, 'Cannot get country information for code:', marketCode);
                    var ret = new CountryEntity({code: marketCode});
                    return RSVP.resolve(ret);
                });
        }

        return RSVP.resolve(cache[marketCode]);
    };

});
